import React from 'react';
import { useTranslation } from 'react-i18next';
import css from './StockEquipmentItem.module.scss';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { StockEquipment } from '../../../interfaces/customer-api';
import { cns } from '../../utils';

interface StockEquipmentPriceProps {
    stockEquipment: StockEquipment;
}

export const StockEquipmentPrice: React.FC<StockEquipmentPriceProps> = ({ stockEquipment }) => {
    const { t } = useTranslation('StockEquipment');

    if (stockEquipment.price == null || !stockEquipment.currency) {
        return null;
    }

    return (
        <>
            <h3>{t('Price')}</h3>
            <div className={cns(css.borderedBox, css.priceBox)}>
                <AttachMoneyIcon className={css.priceIcon} />
                <span>{`${stockEquipment.price} ${stockEquipment.currency}`}</span>
            </div>
        </>
    );
};
